import React, { useEffect, useState } from 'react';
import InputField from '../../../../../../component/form/FormInput';
import arrowDown from '../../../../../../assets/image/arrow_down_dark.svg';
import arrowUp from '../../../../../../assets/image/arrow_up_dark.svg';
import { toast } from 'react-toastify';
import { getRolePermission } from '../../../../../../services/settings/users';
import PageLoader from '../../../../../../component/PageLoader';

/* ================= CONFIG ================= */

const PERMISSION_COLUMNS = [
	{ key: 'View', label: 'View' },
	{ key: 'Create', label: 'Create' },
	{ key: 'Edit', label: 'Edit' },
	{ key: 'Delete', label: 'Delete' },
	{ key: 'Approve', label: 'Approve' },
	{ key: 'Other', label: 'Other' },
];

/* =============== HELPERS ================= */

const findPermissionByLabel = (permissions = [], label) =>
	permissions.find((p) => p.label === label);

/* ============== COMPONENT ================ */

export default function CreateRole({
	form,
	setForm,
	error,
	setError,
	setRolePermissionList,
	rolePermissionList,
}) {
	const [openIndex, setOpenIndex] = useState({});
	const [openOther, setOpenOther] = useState(null);
	const [loader, setLoader] = useState(true);

	const handleFormData = (key, value, required) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (value) {
				delete newError[key];
			} else {
				newError[key] = `Please enter ${key} in the field`;
			}
			setError(newError);
		}
	};

	const toggle = (key) => {
		setForm((prev) => ({
			...prev,
			permissions: prev.permissions.includes(key)
				? prev.permissions.filter((p) => p !== key)
				: [...prev.permissions, key],
		}));
		// setSelected((prev) => (prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key]));
	};

	const toggleModule = (moduleKey) => {
		setOpenIndex((prev) => ({
			...prev,
			[moduleKey]: !prev[moduleKey],
		}));
	};

	const getPermissionColumns = (moduleName) => {
		if (moduleName === 'Documents') {
			return PERMISSION_COLUMNS.map((col) =>
				col.label === 'Create' ? { ...col, label: 'Upload' } : col,
			);
		}
		return PERMISSION_COLUMNS;
	};

	const checked = (key) => form.permissions.includes(key);

	const getRoleList = async () => {
		try {
			setLoader(true);
			const { modules } = await getRolePermission();
			if (modules?.length) {
				const initialOpenIndex = modules.reduce((acc, module) => {
					acc[module.key] = true; // collapsed by default
					return acc;
				}, {});
				setOpenIndex(initialOpenIndex);
			}
			setRolePermissionList(modules);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		getRoleList();
	}, []);

	if (loader) return <PageLoader />;

	return (
		<div className="p-4">
			{/* ================= Role Name ================= */}
			<div className="d-flex align-items-center my-2 gap-4">
				<div className="d-flex gap-1 align-items-center">
					<div className="text-sm font-medium my-3">Role Name</div>
					<div className="fs-6 fw-light text-danger">*</div>
				</div>
				<div className="col-4 my-2">
					<InputField
						type="text"
						value={form?.name}
						onChange={(value) => handleFormData('name', value, true)}
						error={error?.name}
						required
						autoComplete="new-role-name"
					/>
				</div>
			</div>

			{/* ================= Description ================= */}
			<div className="d-flex align-items-center my-2 gap-4">
				<div className="text-sm font-medium my-3">Description</div>
				<div className="col-4 my-2">
					<InputField
						type="text"
						value={form?.description}
						multiline
						rows={3}
						onChange={(value) => handleFormData('description', value)}
						error={error?.description}
						autoComplete="description"
					/>
				</div>
			</div>

			{/* ================= Modules ================= */}
			{rolePermissionList.map((module, index) => (
				<div
					key={module.key}
					className="role-module-header"
				>
					{/* Module Header */}
					<div
						className="d-flex justify-content-between align-items-center py-3 px-3 cursor-pointer"
						onClick={() => toggleModule(module.key)}
						style={{ background: '#F9F9FB' }}
					>
						<div className="fs-4 fw-bold">{module.name}</div>
						<img
							src={openIndex[module.key] ? arrowUp : arrowDown}
							style={{ width: 15, height: 15 }}
							alt=""
						/>
					</div>

					{/* ===== Customization / Dashboard ===== */}
					{(module.name === 'Customization' ||
						module.name === 'Dashboard' ||
						module.name === 'Settings') &&
						openIndex[module.key] &&
						module.sub_modules.map((sub) => (
							<div
								key={sub.key}
								className="d-flex gap-4 align-items-center p-3"
							>
								{sub.permissions
									.filter((p) => p.label === 'View')
									.map((perm) => (
										<label
											key={perm.key}
											className="d-flex gap-3 cursor-pointer"
										>
											<input
												type="checkbox"
												className="form-check-input cursor-pointer"
												checked={checked(perm.key)}
												onChange={() => toggle(perm.key)}
											/>
											{sub.name}
										</label>
										// 		<input
										// 			key={perm.key}
										// 			type="checkbox"
										// 			checked={checked(perm.key)}
										// 			onChange={() => toggle(perm.key)}
										// 		/>
									))}
								{/* // <div style={{ fontWeight: 500 }}>{sub.name}</div> */}
							</div>
						))}

					{/* ===== HEADER ===== */}
					{module.name !== 'Customization' &&
						module.name !== 'Dashboard' &&
						module.name !== 'Settings' &&
						openIndex[module.key] && (
							<div
								style={{
									display: 'grid',
									gridTemplateColumns: `220px repeat(${PERMISSION_COLUMNS.length}, 1fr)`,
									background: '#fff',
									padding: '10px 12px',
									borderRadius: 8,
									fontSize: 13,
									fontWeight: 500,
								}}
							>
								<div>Particular</div>
								{getPermissionColumns(module.name).map((col) => (
									<div key={col.key}>{col.label}</div>
								))}
								{/* {PERMISSION_COLUMNS.map((col) => (
									<div key={col.key}>{col.label}</div>
								))} */}
							</div>
						)}

					{/* ===== ROWS ===== */}
					{module.name !== 'Customization' &&
						module.name !== 'Dashboard' &&
						module.name !== 'Settings' &&
						openIndex[module.key] &&
						module.sub_modules.map((sub) => (
							<div
								key={sub.key}
								style={{ position: 'relative' }} // IMPORTANT for modal stickiness
							>
								<div
									style={{
										display: 'grid',
										gridTemplateColumns: `220px repeat(${PERMISSION_COLUMNS.length}, 1fr)`,
										padding: '12px',
										borderTop: '1px solid #e5e7eb',
										alignItems: 'center',
									}}
								>
									{/* Particular */}
									<div style={{ fontWeight: 500 }}>{sub.name}</div>

									{/* Permissions */}
									{PERMISSION_COLUMNS.map((col) => {
										/* ================= OTHER COLUMN ================= */
										if (col.label === 'Other') {
											const hasOtherPermissions = Array.isArray(sub.other_permissions);

											const isDisabled = hasOtherPermissions && sub.other_permissions.length === 0;

											return (
												<div key="other">
													{hasOtherPermissions && (
														<button
															type="button"
															disabled={isDisabled}
															style={{
																background: 'transparent',
																border: 'none',
																color: isDisabled ? '#9ca3af' : '#2563eb',
																cursor: isDisabled ? 'not-allowed' : 'pointer',
																fontSize: 13,
																padding: 0,
															}}
															onClick={() => {
																if (!isDisabled) {
																	setOpenOther(openOther === sub.key ? null : sub.key);
																}
															}}
														>
															More Permissions
														</button>
													)}
												</div>
											);
										}

										const perm = findPermissionByLabel(sub.permissions, col.label);

										/* ================= APPROVE ================= */
										if (col.label === 'Approve' && !perm) {
											return (
												<div key="approve-disabled">
													<input
														type="checkbox"
														className="form-check-input"
														disabled
													/>
												</div>
											);
										}

										/* ================= EMPTY CELL ================= */
										if (!perm) {
											return <div key={col.label} />;
										}

										/* ================= NORMAL CHECKBOX ================= */
										return (
											<div key={perm.key}>
												<input
													type="checkbox"
													className="form-check-input cursor-pointer"
													checked={checked(perm.key)}
													onChange={() => toggle(perm.key)}
												/>
											</div>
										);
									})}
								</div>

								{/* ================= OTHER PERMISSIONS MODAL ================= */}
								{openOther === sub.key && (
									<div
										className="role-other-permission-dropdown-container"
										style={{
											position: 'absolute',
											top: '100%',
											zIndex: 20,
										}}
									>
										{sub.other_permissions.map((perm) => (
											<label
												key={perm.key}
												className="d-flex gap-3 py-2 cursor-pointer"
											>
												<input
													type="checkbox"
													className="form-check-input cursor-pointer"
													checked={checked(perm.key)}
													onChange={() => toggle(perm.key)}
												/>
												{perm.label}
											</label>
										))}
									</div>
								)}
							</div>
						))}
				</div>
			))}
		</div>
	);
}
